/** @jsxImportSource @emotion/react */
import { Spin } from '@ssmm/ui';
import {
  BlueLine,
  Button,
  Container,
  Controls,
  Divider,
  HeadingH2,
  Section,
} from 'components/landing/ui';
import { arrowRight } from 'components/landing/ui/icons';
import React, { useState } from 'react';

import dots from '../../images/dots.svg';
import Case from './case';
import CaseModal from './modal';

const S7 = React.forwardRef(({ cases }, ref) => {
  const [page, setPage] = useState(1);
  const [selectedCase, setSelectedCase] = useState(null);

  return (
    <>
      <Container ref={ref}>
        <Section
          css={{
            position: 'relative',
            paddingTop: 50,
            '@media (min-width:992px)': { paddingTop: 100 },
            '@media (min-width:1366px)': { paddingTop: 120 },
          }}
        >
          <Spin spinning={!cases} direction="column" width="100%" css={{ minHeight: 300 }}>
            {cases && (
              <>
                <div
                  css={{
                    position: 'absolute',
                    display: 'none !important',
                    top: 110,
                    right: -30,
                    zIndex: -1,
                    background: `url(${dots})`,
                    height: 256,
                    width: 361,

                    '@media (min-width:768px)': { display: 'block !important' },
                    '@media (min-width:992px)': { display: 'none !important' },
                  }}
                />

                <div
                  css={{
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '100%',
                    marginBottom: 30,
                    '@media (min-width:992px)': { marginBottom: 50 },
                  }}
                >
                  <HeadingH2 css={{ marginBottom: 20 }}>Опыт наших пользователей:</HeadingH2>
                  <BlueLine height={5} width={125} />
                </div>

                <div css={{ width: '100%', marginBottom: 45 }}>
                  <Controls
                    title="Специальности"
                    current={page}
                    total={3}
                    onNext={() => setPage(page + 1)}
                    onPrev={() => setPage(page - 1)}
                  />
                </div>

                <div
                  css={{
                    flexWrap: 'wrap',
                    width: '100%',
                    '>div': {
                      flexBasis: '100%',
                      flexShrink: 1,
                      flexGrow: 1,
                      height: 270,
                      flexDirection: 'column',
                      justifyContent: 'flex-end',
                      wordBreak: 'break-word',
                    },
                    '>div:nth-of-type(1)': { marginBottom: 20 },
                    '>div:nth-of-type(2)': { marginBottom: 20 },
                    '>div:nth-of-type(3)': { marginBottom: 20 },
                    '@media (min-width:768px)': {
                      '>div': { flexBasis: '45%', height: 420 },
                      '>div:nth-of-type(1)': { marginRight: 15, marginBottom: 20 },
                      '>div:nth-of-type(2)': { marginBottom: 20 },
                      '>div:nth-of-type(3)': { marginRight: 15, marginBottom: 0 },
                    },
                    '@media (min-width:992px)': {
                      '>div': { flexBasis: '20%', height: 263 },
                      '>div:nth-of-type(1)': { marginRight: 20, marginBottom: 0 },
                      '>div:nth-of-type(2)': { marginRight: 20, marginBottom: 0 },
                      '>div:nth-of-type(3)': { marginRight: 20, marginBottom: 0 },
                    },
                    '@media (min-width:1366px)': {
                      '>div:nth-of-type(1)': { marginRight: 30 },
                      '>div:nth-of-type(2)': { marginRight: 30 },
                      '>div:nth-of-type(3)': { marginRight: 30 },
                    },
                  }}
                >
                  {Object.keys(cases)
                    .slice((page - 1) * 4, page * 4)
                    .map(k => (
                      <Case key={k} target={cases[k]} onClick={() => setSelectedCase(k)} />
                    ))}
                </div>

                <div css={{ marginTop: 50, width: '100%', justifyContent: 'center' }}>
                  <Button
                    type="blue"
                    icon={arrowRight}
                    css={{ width: 316 }}
                    onClick={() => setSelectedCase('menu')}
                  >
                    Все эксперты
                  </Button>
                </div>
              </>
            )}
          </Spin>

          <Divider
            css={{
              marginTop: 50,
              '@media (min-width:992px)': { marginTop: 100 },
              '@media (min-width:1366px)': { marginTop: 120 },
            }}
          />
        </Section>
      </Container>

      {selectedCase !== null && (
        <CaseModal onClose={() => setSelectedCase(null)} selectedCase={selectedCase} />
      )}
    </>
  );
});

export default S7;
